import React, { useEffect, useMemo, useState } from 'react'
import { connect } from 'react-redux'
import { clientLogout } from 'store/actions/app'
import chat_passengerActions from 'store/actions/chat_passenger'
import './Header.scss'
import ReactTooltip from 'react-tooltip'
import { useTranslation } from 'react-i18next'
import { FaChartBar } from 'react-icons/fa6'
import icons from 'components/Icons.js'
import ModalMenu from 'components/ModalMenu/ModalMenu'
import {
  Button,
  Icon,
  Image,
  Grid,
  Header,
  Label,
  Menu,
  Message,
  Popup,
  Segment,
  List,
  Dimmer
} from 'semantic-ui-react'
import HeaderSeparator from './HeaderSeparator'
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min'
import ContentOverlayLoader from 'components/ContentOverlayLoader'

const getAvatar = (client) => {
  let name = 'Guest'
  if (client) {
    name = client?.code
  }
  return `https://ui-avatars.com/api/?name=${name}`
}

const HeaderComponent = (props) => {
  const { t } = useTranslation()
  const {
    client,
    clientLogout,
    setExpand,
    openModal,
    setOpenModal,
    mobileOnly,
    previousExpand,
    setPreviousExpand,
    expand,
    history,
  } = props
  const isSidebarExpanded = mobileOnly ? expand === 1 : expand == null || expand === 1
  const [modalVisible, setModalVisible] = useState(false)
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  // Modal Menu (Configuración)
  const [modalMenuVisible, setModalMenuVisible] = useState(false)
  const [modalMenuTitle, setModalMenuTitle] = useState('')

  const handleModalMenuOpen = (title = '') => {
    setModalVisible(false)
    setModalMenuTitle(title)
    setModalMenuVisible(true)
  }
  const handleModalMenuClose = () => setModalMenuVisible(false)

  let userName = client?.code ?? client.name

  const unreadMessagesCount = useMemo(() => {
    const total = props.unreadMessages?.reduce((acc, m) => acc + Number(m.unread_count || 0), 0)
    return Math.min(total ?? 0, 99)
  }, [props.unreadMessages])

  const unreadMessagesDigits = String(unreadMessagesCount || 0).length

  const messagesLabelStyle = useMemo(() => {
    if (unreadMessagesDigits <= 2) {
      // mantener círculo (ancho = alto) para 1-2 dígitos
      // const size = unreadMessagesDigits === 1 ? 16 : 18
      const size = 24
      return {
        fontFamily: "Lato,'Helvetica Neue',Arial,Helvetica,sans-serif",
        fontSize: '1em',
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: '50%',
        minWidth: `${size}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        top: '-8px',
        right: '-8px',
        // display: 'inline-block',
      }
    } else {
      // para 3 o más dígitos, usar forma "píldora" ajustable en ancho
      const height = 18
      const extra = (unreadMessagesDigits - 2) * 8 // ajustar espacio por dígito extra
      const minW = height + extra + 6
      return {
        fontFamily: "Lato,'Helvetica Neue',Arial,Helvetica,sans-serif",
        fontSize: '1.0em',
        height: `${height}px`,
        padding: '0 8px',
        borderRadius: '999px',
        minWidth: `${minW}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        top: '-8px',
        right: '-10px',
        display: 'inline-block',
      }
    }
  }, [unreadMessagesDigits])

  return (
    <>
      <Menu
        className='NavBar__Header'
        inverted
        borderless
        size='tiny'
        attached='top'
        fixed='top'
        style={{
          // desplazar solo en desktop cuando el lateral está expandido (null o 1)
          left: !mobileOnly && (isSidebarExpanded) ? 225 : 0,
          width: !mobileOnly && (isSidebarExpanded) ? 'calc(100% - 225px)' : '100%',
          transition: 'left 0.5s ease, width 0.5s ease',
          boxShadow: '10px 1px 12px 0px rgba(0,0,0,0.10)',
        }}
      >
        <Menu className='SubMenu__Header' size='mini' secondary style={{
          marginLeft: (!mobileOnly && isSidebarExpanded) ? 8 : 0,
          transition: 'margin-left 0.24s ease',
          display: 'inline-flex',
          alignItems: 'center',
        }}>

          {/* Botón menú: solo visible cuando el sidebar está cerrado o en móvil */}
          <Menu.Item fitted className='NavBar__Item NavBar__SidebarToggle' style={{ padding: 0, marginRight: 6 }}>
            {(!isSidebarExpanded || mobileOnly) && (
              <img
                src='https://img.icons8.com/?size=100&id=g5dx3VExcn2X&format=png&color=000000'
                alt={t('Menu')}
                className='NavBar__Item NavBar__SidebarToggle'
                style={{
                  width: 30,
                  height: 30,
                  cursor: 'pointer',
                  display: 'inline-block',
                  verticalAlign: 'middle',
                  pointerEvents: 'auto'
                }}
                onClick={() => {
                  setExpand((previousExpandedState) => {
                    setPreviousExpand(previousExpandedState)

                    if (!mobileOnly)
                      return previousExpandedState == 1
                        ? previousExpand == null || previousExpand == 2
                          ? 0
                          : 2
                        : 1

                    return !previousExpandedState ? 1 : 0
                  })
                }}
              />
            )}
          </Menu.Item>

          <Menu.Item fitted position='right' data-tip data-for='dashboard-tooltip' >
            <NavLink
              to={'/client/client_dashboard'}
              style={{ display: 'inline-flex', alignItems: 'center' }}
            >
              <img
                src='https://img.icons8.com/?size=100&id=DAoPjn2XoTUN&format=png&color=000000' // <-- reemplaza por la URL/prop de Icons.js
                alt={t('Dashboard')}
                className='NavBar__Item'
                style={{ width: 30, height: 30, display: 'inline-block', verticalAlign: 'middle' }}
              />
            </NavLink>
          </Menu.Item>
          <ReactTooltip id='dashboard-tooltip' place='top' effect='solid' className='tooltip-mini'>
            {t('Dashboard')}
          </ReactTooltip>
          <Menu.Item className='NavBar__Brand'>
            <Header>
              <h4 className='NavBar__Outline'>Geo Transport</h4>
              <Header.Subheader className='NavBar__Outline'>
                V 0.19.60
              </Header.Subheader>
            </Header>
          </Menu.Item>
          <Menu.Item fitted position='right'>
            <img
              src='https://img.icons8.com/?size=100&id=p4rXi9HURgXT&format=png&color=000000' // <-- reemplaza por la URL/prop de Icons.js
              alt={t('Ayuda')}
              className='NavBar__Item'
              style={{ width: 30, height: 30, cursor: 'pointer' }}
              onClick={() => { setOpenModal(!openModal) }}
            />
          </Menu.Item>
        </Menu>
        <Menu.Menu position={mobileOnly ? null : 'right'} borderless size='tiny'>
          {props.client?.permissions?.chat_passenger_permits && (
            <>
              <Popup
                pinned
                trigger={(
                  <Menu.Item
                    fitted
                    position='right'
                    className='NavBar__Item'
                    style={{ padding: '0 0.8em' }}
                    onClick={() => {
                      if (!props.unreadMessages || props.unreadMessages.length === 0) {
                        history.push('/client/passengers?tab=5')
                      }
                    }}
                  >
                    <div style={{ position: 'relative', display: 'inline-block', }}>
                      <img
                        src='https://img.icons8.com/?size=100&id=hCvhdugyicF1&format=png&color=000000'
                        alt={t('Chat')}
                        className='NavBar__Item'
                        style={{ width: 30, height: 30, cursor: 'pointer' }}
                      />
                      {unreadMessagesCount > 0 && (
                        <Label
                          color='red'
                          floating
                          circular
                          style={messagesLabelStyle}
                        >
                          {unreadMessagesCount}{unreadMessagesDigits > 2 ? <span style={{ fontSize: '0.9em' }}>+</span> : null}
                        </Label>
                      )}
                    </div>
                  </Menu.Item>
                )}
                content={
                  <div>
                    <div style={{ maxHeight: 200, overflowY: 'auto' }}>
                      <List selection divided verticalAlign='center' style={{ marginTop: 0, marginBottom: 8 }}>
                        {props.unreadMessages?.map((m) => (
                          <List.Item
                            key={m.id}
                            onClick={() => {
                              props.setActiveChatId(m.chat_id)
                              history.push('/client/passengers?tab=5', {
                                header: {
                                  chatId: m.chat_id,
                                  clientId: m.ChatPassenger?.GroupPassenger?.client_id,
                                }
                              })
                            }}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              padding: '0.5em 0.75em',
                            }}
                          >
                            <List.Content
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                flex: 1,
                              }}
                            >
                              <List.Header
                                style={{
                                  fontWeight: 500,
                                  margin: 0,
                                }}
                              >
                                {m.ChatPassenger?.GroupPassenger?.name}
                              </List.Header>
                            </List.Content>

                            <Label circular>
                              {m.unread_count}
                            </Label>
                          </List.Item>
                        ))}
                      </List>
                    </div>

                    <div style={{ display: 'flex' }}>
                      <Button
                        size='mini'
                        fluid
                        primary
                        onClick={() => {
                          history.push('/passengers?tab=5')
                        }}
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}
                      >
                        <Icon name='bell outline' />
                        {t('Todos los mensajes')}
                      </Button>
                    </div>
                  </div>
                }
                position='bottom right'
                on='click'
              />
              <HeaderSeparator />
            </>
          )}
          <Menu.Item fitted position='right' className='NavBar__Item'>
            <Popup
              onOpen={() => setModalVisible(true)}
              onClose={() => setModalVisible(false)}
              open={modalVisible}
              pinned
              on='click'
              trigger={
                <Menu.Item className='NavBar__Item' style={{ marginRight: '25px' }}>
                  <Image src={client?.sysCompanyImage?.logo_url} avatar />
                  <span className='ClientHeader__ProfileName'>{(client?.email || client?.username || '').slice(0, 10)}</span>
                </Menu.Item>
              }
              content={
                <Segment className="Header_PopUp NavBar__Outline">
                  <div className="Header_PopUp_List">

                    {/* Logo */}
                    <div className="Header_PopUp_Item">
                      <div className="Header_PopUp_Button logo">
                        <Image
                          src={client?.sysCompanyImage?.logo_url}
                          avatar
                        />
                      </div>
                    </div>

                    {/* Usuario */}
                    <div className="Header_PopUp_Item">
                      <h4 className="NavBar__InvertedOutline">
                        {userName.toUpperCase()}
                      </h4>
                    </div>

                    {/* Configuración */}
                    <div className="Header_PopUp_Item">
                      <Button
                        onClick={() => handleModalMenuOpen(t('Configuración'))}
                        className="Header_PopUp_Button settings"
                      >
                        {t('Configuración')}
                        <img
                          src={icons.find(i => i.title === 'ConfiguracionUser')?.url}
                          alt={t('Configuración')}
                          className="Header_Button_Icon"
                        />
                      </Button>
                    </div>

                    {/* Logout */}
                    <div className="Header_PopUp_Item">
                      <Button
                        className="Header_PopUp_Button logout"
                        onClick={async () => {
                          setIsLoggingOut(true);
                          await clientLogout(client?.id)
                          setIsLoggingOut(false);
                          props.history.push(
                            `/login${client?.sys_company_data?.logo_token
                              ? '?e=' + client?.sys_company_data?.logo_token
                              : ''
                            }`
                          )
                        }}
                      >
                        {t('Cerrar sesión')}
                        <img
                          src={icons.find(i => i.title === 'LogOutUser')?.url}
                          alt={t('Cerrar sesión')}
                          className="Header_Button_Icon"
                        />
                      </Button>
                    </div>
                  </div>
                </Segment>
              }
              position="bottom right"
            />
          </Menu.Item>
        </Menu.Menu>

        <ModalMenu
          open={modalMenuVisible}
          onClose={handleModalMenuClose}
          title={modalMenuTitle}
          profile="client"
        />
      </Menu>

      {isLoggingOut && (
        <ContentOverlayLoader active={isLoggingOut} text={t('Cerrando sesión...')} />
      )}
    </>
  )
}

const mapDispatchToProps = (dispatch) => ({
  clientLogout: (option) => dispatch(clientLogout(option)),
  setActiveChatId: (id) => dispatch(chat_passengerActions.setActiveChatId(id)),
})

const mapStateToProps = (state) => ({
  isClientAuthenticated: !!state.app.client,
  client: state.app.client,
  unreadMessages: state.chat_passengers?.unreadMessages,
})

export default connect(mapStateToProps, mapDispatchToProps)(HeaderComponent)
